import React, { Component, Fragment } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';

import { stableSort, getSorting } from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';
import { EditableTableRow } from '../Common/TableHead/EditableTableRow';

export class AddEditSellers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data
            , editing: false
            , addingNewRow: false
            , order: 'asc'
            , orderBy: 'OrderPos'
            , page: 0
            , rowsPerPage: 10
            , loading: false
        };
    }

    refreshData = () => {
        let DEFAULT_QUERY = "getsellers";

        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(result => {
            this.setState({ loading:false, data: result.data });
        });
    }

    handleSearch = (search) => {
        fetch(API + "searchsellers&keyword=" + search)
            .then(response => response.json())
            .then(data => this.setState({ data: data?.data, page: 0 }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    saveRow = (params) => {
        let DEFAULT_QUERY = "saveseller&sellerid=" + params.Id + "&name=" + params.Name + "&external=" + params.External
                            + "&cutpercent=" + params.CutPercent + "&hasvoucher=" + params.HasVoucher + "&orderpos=" + params.OrderPos  
                            + "&notes=" + params.Notes + "&isactive=" + params.IsActive
                            + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

        this.setState({ loading: true });

        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(result => {
            const modalParams = {
                returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
                , returnType: result.shortmsg === "OK" ? 1 : 2
                , returnText: result.message
            }
            this.props.openModal(modalParams);
            this.refreshData();
        });
    }

    addRow = () => {
        this.setState({ addingNewRow: true, editing: true });
    }

    deleteRow = (id) => {
        let newData = [...this.state.data];

        newData = newData.filter(x => x.Id !== id);

        if(id === "new"){
            this.setState({ data: newData });
            return;
        }
        
        if(window.confirm("Tem a certeza que quer apagar este vendedor?")){
            let DEFAULT_QUERY = "deleteseller&sellerid=" + id + 
                                "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

            this.setState({ loading: true });

            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {
                const modalParams = {
                    returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
                    , returnType: result.shortmsg === "OK" ? 1 : 2
                    , returnText: result.message
                }
                this.props.openModal(modalParams);

                this.setState({ loading:false, data: newData });
            });
        }
    }

    onEditing = () => {
        this.setState({ editing: true });
    }

    onStopEditing = () => {
        this.setState({ editing: false, addingNewRow: false });
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const sellers = this.state.data || []
            , { order, orderBy, rowsPerPage, page, editing, loading, addingNewRow } = this.state
            , fakeRow = { Id: "new", Name: "", External: 0, CutPercent: 0, HasVoucher: 0, OrderPos: 0, Notes: "", IsActive: 1 }
            , headerRows = [
                { id: 'Name', type: "text", label: 'Nome' },
                { id: 'CutPercent', type: "number", label: 'Percentagem' },
                { id: 'Notes', type: "textarea", label: 'Notas' },
                { id: 'IsExternal', type: "checkbox", label: 'Externo' },
                { id: 'HasVoucher', type: "checkbox", label: 'Voucher' },
                { id: 'OrderPos', type: "number", label: 'Posição' },
                { id: 'IsActive', type: "checkbox", className: 'smallerHeader', label: 'Ativo' },
                { id: 'actions', notSortable: true, label: 'Ações' },
            ];

        return (
            <Fragment>
                <div className="row">
                    <Search id="s_search" searchCallback={this.handleSearch} className="col-12 col-md-4" />
                </div>
                <div className="row header">
                    <div className="col-12">
                        <h2>
                            <i className="fa fa-user-tie"></i> Tipos de Vendedores
                            { (isAdmin || (loginData.profile.Settings?.ADD)) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Vendedor"}
                                        enterDelay={200}>
                                        <span>
                                            <button disabled={editing} type="button" className="simpleBtn actionButton success" onClick={this.addRow} ><i className="fa fa-plus"></i></button>
                                        </span>
                                    </Tooltip>
                                </span>
                            }
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Table className={"responsiveTable customTable" + (loading ? " ajaxLoading" : "")}>
                            <EnhancedTableHead
                                className="tableRow tableHeader"
                                headerRows={headerRows}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={sellers.length}>
                            </EnhancedTableHead>
                            <TableBody>                             
                                { addingNewRow && 
                                    <EditableTableRow 
                                        tableLabel={"Vendedor"}
                                        editing={editing}
                                        key={"s_" + fakeRow.Id}
                                        isAdmin={isAdmin} 
                                        loginData={loginData} 
                                        rowId={"s_" + fakeRow.Id}
                                        data={fakeRow} 
                                        rows={headerRows} 
                                        onEdit={this.onEditing}
                                        onStopEdit={this.onStopEditing}
                                        deleteRow={this.deleteRow}
                                        saveRow={this.saveRow} />
                                }
                                {stableSort(sellers, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(s => {
                                        return (
                                            <EditableTableRow 
                                                tableLabel={"Vendedor"}
                                                editing={editing}
                                                key={"s_" + s.Id}
                                                isAdmin={isAdmin} 
                                                loginData={loginData} 
                                                rowId={"s_" + s.Id}
                                                data={s} 
                                                rows={headerRows} 
                                                onEdit={this.onEditing}
                                                onStopEdit={this.onStopEditing}
                                                deleteRow={this.deleteRow}
                                                saveRow={this.saveRow} />
                                        );
                                    }
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10]}
                            component="div"
                            count={sellers.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}
